import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

//const baseUrl = environment.apiUrl;

@Injectable({
  providedIn: "root",
})
export class EcommerceNpService {
  constructor(private http: HttpClient) {}

  headersFile: HttpHeaders = new HttpHeaders({
    "Mime-Type": "multipart/form-data",
  });

  getAll(baseUrl: any, urlApi: any): Observable<any> {
    return this.http.get(baseUrl + urlApi, { observe: "response" });
  }

  getById(baseUrl: any, urlApi: any, id): Observable<any> {
    return this.http.get(baseUrl + urlApi + id, { observe: "response" });
  }

  getParam(baseUrl: any, urlApi: any, param: any): Observable<any> {
    //////console.log(urlApi);
    let ultimocaracter = urlApi.substr(urlApi.length - 1);
    let paramUrl: any = "";
    if (ultimocaracter == "/") {
      param.forEach((el) => {
        paramUrl += el.valor + "/";
      });
    } else {
      paramUrl = "?";
      param.forEach((el) => {
        if (typeof el.valor != undefined) {
          if (el.valor != null) {
            if (el.valor.length != 0)
              paramUrl += el.clave + "=" + el.valor + "&";
          }
        }
      });
    }

    let resparam = baseUrl + urlApi + paramUrl;
    return this.http.get(resparam, { observe: "response" });
  }
  create(baseUrl: any, urlApi: any, param: any): Observable<any> {
    return this.http.post(baseUrl + urlApi, JSON.stringify(param), {
      observe: "response",
    });
  }
  createFile(baseUrl: any, urlApi: any, id: any, data: FormData) {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", baseUrl + urlApi + id, true);
    xhr.onload = function () {
      if (this["status"] === 200) {
        const responseText = this["responseText"];
      }
    };
    xhr.send(data);
  }
  update(baseUrl: any, urlApi: any, param: any): Observable<any> {
    return this.http.put(baseUrl + urlApi, JSON.stringify(param), {
      observe: "response",
    });
  }

  updateId(baseUrl: any, urlApi: any, id: any, param: any): Observable<any> {
    return this.http.put(baseUrl + urlApi + id, JSON.stringify(param), {
      observe: "response",
    });
  }

  delete(baseUrl: any, urlApi: any, id: any): Observable<any> {
    return this.http.delete(baseUrl + urlApi + id, { observe: "response" });
  }

  deleteWithContent(
    baseUrl: any,
    urlApi: any,
    id: any,
    param: any
  ): Observable<any> {
    return this.http.delete(baseUrl + urlApi + id + "?NotasTram=" + param, {
      observe: "response",
    });
  }

  getImage(baseUrl: any, urlApi: any, id): Observable<any> {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("ACCESS_TOKEN"),
    });
    return this.http.get(baseUrl + urlApi + id, {
      headers: headers,
      responseType: "blob",
    });
  }
  // getEnum(baseUrl: any, urlApi: any, tipo: any) {
  //   let headers = new HttpHeaders({
  //     "Content-Type": "application/json",
  //   });
  //   let urlProductos = "";
  //   urlProductos = baseUrl + "/TEnum/Tipo?tipo=" + tipo + "&len=1";
  //   return this.http.get(urlProductos, { headers: headers });
  // }
  createFileMultipart(baseUrl, urlApi, id, data: FormData): Observable<any> {
    return this.http.post(baseUrl + urlApi + id, data, { observe: "response" });
  }
}
